import React from 'react';
import { CopyToClipboardButton } from '../../../../components/CopyToClipboardButton';
import { Field, FieldGrid, SectionCard } from '../../../../components/Section';
import { IDerayahOrderDetails } from '../../../../types/derayah';
import { DerayahStatusChip } from './DerayahStatusChip';
import { formatOptionalDateTime } from './format';

interface DerayahOrderSummaryProps {
  order: IDerayahOrderDetails;
}

export function DerayahOrderSummary({ order }: DerayahOrderSummaryProps) {
  return (
    <SectionCard title="Order">
      <FieldGrid columns={3}>
        <Field label="Order type" value={order.type} />
        <Field label="Order status">
          <DerayahStatusChip status={order.status} />
        </Field>
        <Field label="Portfolio order UUID">
          <CopyToClipboardButton value={order.orderId} />
        </Field>
        <Field label="Derayah order ID" value={order.id} />
        <Field label="User ID" value={order.userId} />
        <Field label="Created at" value={formatOptionalDateTime(order.createdAt)} />
        <Field label="Last updated at" value={formatOptionalDateTime(order.updatedAt)} />
      </FieldGrid>
    </SectionCard>
  );
}
